import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { WriteDown } from '../components/write-down/write-down';
import { PulseBackgroundWave } from '../components/pulse-background';
import { HueSlider } from '../components/hue-slider/hue-slider';
import { HueColorBubbles } from '../components/hue-color-bubbles';
import { useI18n } from '../i18n';
import { Icon } from '../components/icon/icon';
import './home.scss';

export const Home: React.FC = () => {
    const { translations } = useI18n();
    const [sliderActive, setSliderActive] = useState(false);
    const [writingDone, setWritingDone] = useState(false);
    const [hue, setHue] = useState(100);

    const heading = sliderActive ? translations.home.sliderH2 : translations.home.greeting;
    const message = sliderActive ? translations.home.sliderMessage : translations.home.message;

    return (
        <>
            {/* <PulseBackgroundWave mode="loop" placement="fullscreen" /> */}
            <main className="page hero home-page">
            <section className="hero header">
                <div className="header-brand">
                    <div className="logo">
                        <span className='desktop'>Guilherme <br />Araujo</span>
                        <span className='mobile'>garaujo</span>
                    </div>
                </div>
                {/* <div className='hero-avatar'>

                </div> */}
                <div className="header-description">
                    <h2>{heading}</h2>
                    <WriteDown className='write-down' mode='ai-chat' onComplete={() => setWritingDone(true)}>
                        {message}
                    </WriteDown>
                    {writingDone && (
                        <Link to="/career" className="footer-nav__link home-explore">
                            <span className='footer-nav__title'>
                                {translations.home.explore} <Icon name='arrow-right' size="1.5em" />
                            </span>
                        </Link>
                    )}
                </div>
                <div className='home-social-links'>
                    <a href="https://aifront.substack.com" target="_blank">substack</a> | <a href="https://linkedin.com/in/guilhermeasouza" target="_blank">linkedin</a> | <a href="https://codepen.io/fromspace" target="_blank">codepen</a> | <a href="https://www.behance.net/guilhermeasouza" target="_blank">behance</a>
                </div>
            </section>
            <div className="home-hue-slider">
                <HueSlider onActiveChange={setSliderActive} onHueChange={setHue} variant='circular' />
                <HueColorBubbles hue={hue} />
            </div>
            </main>
        </>
    );
};

export default Home;